import logo from './logo.svg';
import './App.css';
import csvData from './data/data-2026-april.csv';
import { useEffect, useMemo, useState } from 'react';
import Papa from 'papaparse';
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import { useDebounce } from 'use-debounce';

// const data = Papa.parse(csvData, {header: true});

function App() {

  const [level, setLevel] = useState('all');
  const [gender, setGender] = useState('all');
  const [age, setAge] = useState('all');
  const [state, setState] = useState('all');
  const [search, setSearch] = useState('');
  const [data, setData] = useState([]);

  const [currentUser, setCurrentUser] = useState(null);

  const [debouncedSearch] = useDebounce(search, 300);

  useEffect(() => {
    Papa.parse(csvData, {
      download: true,
      header: true,
      complete: results => { "SETTING DATA"; setData(results.data) }
    });
  }, []);

  const levels = ['2.5', '3.0', '3.5', '4.0', '4.5'];
  const genders = ['F', 'M'];
  const ages = ['01-17', '15-34', '35-49', '50-59', '60-69', '70+'];
  const states = [
    'Alabama',
    'Florida',
    'Georgia',
    'Kentucky',
    'Louisiana',
    'Mississippi',
    'North Carolina',
    'South Carolina',
    'Tennessee',
    'Texas',
    'Virginia'
  ];

  // console.log(csvData);
  // console.log(data);

  function reset() {
    setLevel('all');
    setGender('all');
    setAge('all');
    setState('all');
    setSearch('')
  }

  // const states = [...new Set(data.map(row => row.State))].filter(state => !['California', 'Michigan', 'Texas', 'Virginia', 'West Virginia', 'Wisconsin'].includes(state));

  const rows = useMemo(() => {
    const filteredData = structuredClone(data.filter(person =>
      person["Age Bucket"] !== "01-14" &&
      (level == 'all' || person["Skill Level"] == level) &&
      (gender == 'all' || person["Gender"] == gender) &&
      (age == 'all' || person["Age Bucket"] == age) &&
      (state == 'all' || person["State"] == state)
    ));
    const pivotData = filteredData.reduce((prev, curr) => {
      const name = curr["Full Name"]?.toLowerCase();
      if (name == 'john waters') {
        if (prev[name]) {
          console.log("OLD", prev[name]["Medal Value"]);
        }

        console.log(curr["Medal Value"]);
        console.log(curr["MEDAL Earned"]);
      }
      if (prev.hasOwnProperty(name)) {
        prev[name]["Medal Value"] += parseInt(curr["Medal Value"]);
        switch (curr["MEDAL Earned"]) {
          case "GOLD":
            prev[name]["Gold Value"] += parseInt(curr["Medal Value"]);
            break;
          case "SILVER":
            prev[name]["Silver Value"] += parseInt(curr["Medal Value"]);
            break;
          case "BRONZE":
            prev[name]["Bronze Value"] += parseInt(curr["Medal Value"]);
            break;
        }
        if (prev[name]["medals"].hasOwnProperty(curr["Event Name"])) {
          prev[name]["medals"][curr["Event Name"]].push({
            eventDate: curr["Event Date"],
            eventLevel: curr["Event Level"],
            gender: curr["Gender Game"],
            skill: curr["Skill Level"],
            medal: curr["MEDAL Earned"],
          })
        }
        else {
          prev[name]["medals"][curr["Event Name"]] = [{
            eventDate: curr["Event Date"],
            eventLevel: curr["Event Level"],
            gender: curr["Gender Game"],
            skill: curr["Skill Level"],
            medal: curr["MEDAL Earned"],
          }];
        }

      }
      else {
        prev[name] = curr;
        prev[name]["Medal Value"] = parseInt(prev[name]["Medal Value"]);
        prev[name]["Gold Value"] = 0;
        prev[name]["Silver Value"] = 0;
        prev[name]["Bronze Value"] = 0;
        switch (curr["MEDAL Earned"]) {
          case "GOLD":
            prev[name]["Gold Value"] += parseInt(curr["Medal Value"]);
            break;
          case "SILVER":
            prev[name]["Silver Value"] += parseInt(curr["Medal Value"]);
            break;
          case "BRONZE":
            prev[name]["Bronze Value"] += parseInt(curr["Medal Value"]);
            break;
        }
        prev[name]["medals"] = {};
        prev[name]["medals"][curr["Event Name"]] = [{
          eventDate: curr["Event Date"],
          eventLevel: curr["Event Level"],
          gender: curr["Gender Game"],
          skill: curr["Skill Level"],
          medal: curr["MEDAL Earned"],
        }];
      }
      return prev;
    }, {});


    const rowData = Object.values(pivotData);
    rowData.sort((a, b) => b["Medal Value"] - a["Medal Value"]);
    let rank = 0;
    let previousValue = 0;
    let ties = 1;
    const rowValues = rowData.map((row, idx) => {
      if (row["Medal Value"] == previousValue) {
        ties++;
      }
      else {
        rank += ties;
        ties = 1;
        previousValue = row["Medal Value"];
      }
      return {
        rank,
        name: row["Full Name"] ?? '',
        gold: row["Gold Value"],
        silver: row["Silver Value"],
        bronze: row["Bronze Value"],
        value: row["Medal Value"],
        row
      }
    });
    const rows = rowValues.filter(d => search == '' || d.name.toLowerCase().includes(search.toLowerCase())).map((row, idx) => {
      return (
        <tr key={idx}>
          <td>{row.rank}</td>
          <td><a href="#" onClick={(e) => { e.preventDefault(); setCurrentUser(row.row) }}>{row.name}</a></td>
          <td>{row.gold}</td>
          <td>{row.silver}</td>
          <td>{row.bronze}</td>
          <td>{row.value}</td>
        </tr>
      )
    });

    return rows;
  }, [data, level, gender, age, state, debouncedSearch]);


  return (
    <div className="App p-3" style={{ width: '800px', maxWidth: '100%' }}>
      <div className="filters row  gy-2 mb-2 justify-content-center align-items-end">
        <div className="filter col-sm-auto">
          <label for="levelSelect" className="form-label"><strong>Skill</strong></label>
          <select name="" id="levelSelect" className="form-select" onChange={(e) => setLevel(e.target.value)} value={level}>
            <option value="all">All</option>
            <option value="2.5">2.5</option>
            <option value="3.0">3.0</option>
            <option value="3.5">3.5</option>
            <option value="4.0">4.0</option>
            <option value="4.5">4.5</option>
          </select>
        </div>
        <div className="filter col-sm-auto">
          <label for="genderSelect" className="form-label"><strong>Gender</strong></label>
          <select name="" id="genderSelect" className="form-select" onChange={(e) => setGender(e.target.value)} value={gender}>
            <option value="all">All</option>
            <option value="F">Female</option>
            <option value="M">Male</option>
          </select>
        </div>
        <div className="filter col-sm-auto">
          <label for="ageSelect" className="form-label"><strong>Age</strong></label>
          <select name="" id="ageSelect" className="form-select" onChange={(e) => setAge(e.target.value)} value={age}>
            <option value="all">All</option>
            {/* <option value="01-17">01-17</option> */}
            <option value="18-34">15-34</option>
            <option value="35-49">35-49</option>
            <option value="50-59">50-59</option>
            <option value="60-69">60-69</option>
            <option value="70+">70+</option>
          </select>
        </div>
        <div className="filter col-sm-auto">
          <label for="ageSelect" className="form-label"><strong>State</strong></label>
          <select name="" id="ageSelect" className="form-select" onChange={(e) => setState(e.target.value)} value={state}>
            <option value="all">All</option>
            {states.filter(state => state).sort().map(state => <option key={state} value={state}>{state}</option>)}
          </select>
        </div>
        <div className="col-sm-auto">
          <button className="btn btn-outline-dark btn-sm" onClick={reset}>Reset</button>
        </div>
      </div>
      <div className="row mb-4 justify-content-center">
        <div className="col-12 col-md-6">
          <input type="search" className="form-control" placeholder="Search by name..." value={search} onChange={e => setSearch(e.target.value)} />
        </div>
      </div>
      <div className="results" style={{ overflow: 'auto', height: '500px' }}>
        <table className="table table-sm table-striped">
          <thead className="thead-dark">
            <tr>
              <th style={{ position: 'sticky', top: '0', zIndex: '1' }}>Rank</th>
              <th style={{ position: 'sticky', top: '0', zIndex: '1' }}>Player</th>
              <th style={{ position: 'sticky', top: '0', zIndex: '1' }}>Gold Points</th>
              <th style={{ position: 'sticky', top: '0', zIndex: '1' }}>Silver Points</th>
              <th style={{ position: 'sticky', top: '0', zIndex: '1' }}>Bronze Points</th>
              <th style={{ position: 'sticky', top: '0', zIndex: '1' }}>Total Points</th>
            </tr>
          </thead>
          <tbody>
            {rows}
          </tbody>
        </table>
      </div>
      <p className="text-end"><small>Updated: 4/13/26</small></p>
      <Modal show={!!currentUser} onHide={() => setCurrentUser(null)}>
        <Modal.Header closeButton>
          <Modal.Title>Medals Won - {currentUser?.["Full Name"]}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <ul>
            {
              currentUser?.medals && Object.entries(currentUser.medals).map(([eventName, medals], i) => {
                console.log(data);
                return (
                  <li key={i}>
                    {eventName} - {medals[0].eventDate}
                    <ul>
                      {medals.map((medal, i) => (
                        <li key={i}>
                          <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill={getMedalColor(medal.medal)} class="bi bi-award-fill" viewBox="0 0 16 16">
                            <path d="m8 0 1.669.864 1.858.282.842 1.68 1.337 1.32L13.4 6l.306 1.854-1.337 1.32-.842 1.68-1.858.282L8 12l-1.669-.864-1.858-.282-.842-1.68-1.337-1.32L2.6 6l-.306-1.854 1.337-1.32.842-1.68L6.331.864z" />
                            <path d="M4 11.794V16l4-1 4 1v-4.206l-2.018.306L8 13.126 6.018 12.1z" />
                          </svg>
                          &nbsp;{medal.gender} <span className={`badge rounded-pill ${getBadgeClass(medal.skill)}`}>{medal.skill}</span></li>
                      ))}
                    </ul>
                  </li>
                )
              })
            }
          </ul>
        </Modal.Body>
      </Modal>
    </div>
  );
}

function getBadgeClass(skill) {
  switch (skill) {
    case "2.5":
      return "text-bg-primary";
    case "3.0":
      return "text-bg-secondary";
    case "3.5":
      return "text-bg-success";
    case "4.0":
      return "text-bg-danger";
    case "4.5":
      return "text-bg-warning";
  }
}

function getMedalColor(medal) {
  switch (medal) {
    case "GOLD":
      return "#FFD700";
    case "SILVER":
      return "#C0C0C0";
    case "BRONZE":
      return "#CD7F32";
  }
}

export default App;
